import { addMinutes, OwaDate } from 'owa-datetime';
import {
    getDefaultShouldShortenEventDurationStartLate,
    getDefaultEndLongEventsBy,
    getDefaultEndShortEventsBy,
} from 'owa-calendar-cloud-settings';

/**
 * Update the event start time when the 'Shorten events duration' setting is on
 * Used when selection is changed in scheduling grid and scheduling assistant
 * @param originalDuration
 * @param newStart
 * @param resetStart
 */
export default function getConfiguredEventStartTimeBasedOnPreviousDuration(
    originalDuration: number,
    newStart: OwaDate
): OwaDate {
    if (!getDefaultShouldShortenEventDurationStartLate()) {
        return newStart;
    }

    const endShortEventsBy = getDefaultEndShortEventsBy();
    const endLongEventsBy = getDefaultEndLongEventsBy();

    if (originalDuration >= 60 - endLongEventsBy) {
        return addMinutes(newStart, endLongEventsBy);
    }

    return addMinutes(newStart, endShortEventsBy);
}
